import React, { useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'

import styles from '../../Users/List/List.module.css'

import { getUsers } from '../../../actions/auth'
import User from './User'

const List = () => {

    
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getUsers())
    }, [dispatch])


    const allUsers = useSelector(state => state.allUsers)
    console.log(allUsers)

    return (
        <div className={styles.users}>
            {/* <div className={styles.totalContainer}>
                <div className={styles.totalUsers}>{allUsers.length}</div>
                <div className={styles.number}>Total users</div>
            </div> */}
            {
                allUsers.map((user) => (
                    <User key={user._id} user={user} />
                ))
            }
           
            
        </div>
    )
}

export default List
